// extracted by mini-css-extract-plugin
export default {"header":"bvJDBfRJ6vV7glHBg3mE"};